// render a google map preview given the placeId as a prop

import { GOOGLE_MAPS_API_KEY } from '@modules/config';
import { Box } from '@mui/material';
import { memo } from 'react';

function MapPreview({ placeId }: { placeId: string | null }) {
    if (!placeId) {
        return null;
    }

    console.log(`[MapPreview] placeId: `, {
        placeId,
        fullURL: `https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_API_KEY}&q=place_id:${placeId}`,
    });

    return (
        <Box paddingY={1}>
            <iframe
                width="350"
                height="300"
                frameBorder="0"
                style={{ border: 0 }}
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_API_KEY}&q=place_id:${placeId}&zoom=13`}
                allowFullScreen
            ></iframe>
        </Box>
    );
}

export default memo(MapPreview);
